/**
 * Progress helpers for assessments that list one questionnaire per navigation
 * item. Only the selected questionnaire is mounted, so the list falls back to
 * counting stored answers for the questionnaires that are not rendered yet.
 */

export const isAnswered = (answer) => {
    if (Array.isArray(answer)) {
        return answer.length > 0;
    }

    if (answer instanceof Date) {
        return true;
    }

    if (answer !== null && typeof answer === "object") {
        return Object.keys(answer).length > 0;
    }

    return answer !== "" && answer !== null && answer !== undefined;
};

/**
 * Flattens the section/questions shape produced by
 * helpers.makeQuestionsReadyForQuestionnaire().
 */
export const getQuestionnaireQuestions = (sections) => {
    return (sections || []).flatMap((section) => {
        return section?.questions || [];
    });
};

export const getQuestionnaireProgress = (sections, answers) => {
    const questions = getQuestionnaireQuestions(sections);
    const answered = questions.filter((question) => {
        return isAnswered(answers?.[question.id]);
    }).length;

    return {
        answered,
        total: questions.length,
        percent: questions.length
            ? Math.round((answered / questions.length) * 100)
            : 0
    };
};

/**
 * Sums per-questionnaire progress into a single completion percentage for the
 * assessment card at the top of the tab.
 */
export const getOverallPercent = (progressList) => {
    const totals = (progressList || []).reduce(
        (result, progress) => {
            result.answered += progress?.answered || 0;
            result.total += progress?.total || 0;

            return result;
        },
        { answered: 0, total: 0 }
    );

    return totals.total
        ? Math.round((totals.answered / totals.total) * 100)
        : 0;
};
